import * as angular from "angular";
import {IQService, IWindowService} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../commons/services/analytics-service.service";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {RouteRequestsService} from "./routes-requests.service";
import {PlanningAlertsService} from "../../planning/services/planning-alerts.service";
import {LeanPlanningAlertsService} from "../../lean-planning/services/lean-planning-alerts.factory";
import {LeanPlanningRequestsService} from "../../lean-planning/services/plan-requests.factory";
import {RoutesListPayloadModel} from "../models/routes-list-payload.model";
import {
  EditDispatchedRouteNameRequestModel
} from "../models/edit-dispatched-route-name-request.model";
import {RouteExportRowType} from "../enums/route-export-row.type";
import {TaskModel} from "../../tasks/models/task.model";
import {RouteTaskModel} from "../models/route-task.model";
import {TaskType} from "../../tasks/types/task.type";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {ChangeRouteResourceQueryModelModel} from "../models/change-route-resource-query-model.model";
import {GetRouteIdsByQueryPayloadModel} from "../models/get-route-ids-by-query-payload.model";

export class RoutesService {

  constructor(private routeRequestsService: RouteRequestsService, private leanPlanningRequestsService: LeanPlanningRequestsService, private $q: IQService, private bringozLoaderService: BringozLoaderService,
              private splitService: SplitService, private $state, private analyticsService: AnalyticsService,
              private $window: IWindowService, private filePrinter, private fileDownloader,
              private $log, private planningAlertsService: PlanningAlertsService, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private commonsAlertsService: CommonsAlertsService) {
  }

  getRoutes(ids, tags, expanded) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.getRoutes(ids, tags, expanded)
      .then((res) => {
        deferred.resolve(_.get(res, 'list', res));
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise
  }

  getRouteIdsByQuery(queries: GetRouteIdsByQueryPayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.getRouteIdsByQuery(queries)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise
  }

  getRoutesBySyncIds(syncIds, expanded) {
    const deferred = this.$q.defer();

    // bringozLoaderService.on();
    this.routeRequestsService.getRoutesBySyncIds(syncIds, expanded)
      .then((result) => {
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        // bringozLoaderService.off();
      });

    return deferred.promise
  }

  getRoutesStatusesTotals(ids?, from?, to?, branchIds?, areaIds?, query?, tags?, agentIds?: string[], agentSkills?: string[], resourceIds?: string[], statuses?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.getRoutesStatusesTotals(ids, from, to, branchIds, areaIds, query, tags, agentIds, agentSkills, resourceIds, statuses, depotIds, resourceTags, vehicleTypeIds, relationTypes)
      .then((totals) => {
        deferred.resolve(totals);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateRoutesName(payload: EditDispatchedRouteNameRequestModel, routeId: string) {
    const deferred = this.$q.defer();
    this.bringozLoaderService.on();
    this.routeRequestsService.editRouteName(routeId, payload)
    .then((result) => {
      this.planningAlertsService.updateRouteSuccess();
      deferred.resolve(result);
    })
    .catch((error) => {
      this.$log.error(error);
      this.planningAlertsService.updateRouteError();
      deferred.reject(error)
    }).finally(() => {
      this.bringozLoaderService.off();
    });

    return deferred.promise;
  }

  updateRouteMetaData(routeId: string, metaData: { key: string, value: string }[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.addRouteMetadata(routeId, metaData)
      .then((updatedRoute) => {
        this.commonsAlertsService.updateMetaDataSuccess();
        deferred.resolve(updatedRoute);
      })
      .catch((error) => {
        this.commonsAlertsService.updateMetaDataError();
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  exportRoutes(ids, excludedIds?, branchIds?, areaIds?, statuses?, from?, to?,
               query?, agentSkills?: string[], routeExportRowType?: RouteExportRowType,
               tags?: string[], resourceIds?: string[], depotIds?: string[], resourceTags?: string[], vehicleTypeIds?: string[], relationTypes?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.exportRoutes(ids, excludedIds, branchIds, areaIds, statuses, from, to, query, agentSkills, routeExportRowType, tags, resourceIds, depotIds, resourceTags, vehicleTypeIds, relationTypes)
      .then((result) => {
        this.planningAlertsService.exportRouteSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.exportRouteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise
  }

  exportIntegrationRoutes(ids, branchIds?, areaIds?, statuses?, from?, to?, query?, agentSkills?: string[], tags?: string[], resourceIds?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.leanPlanningRequestsService.exportIntegrationRoutes(ids, branchIds, areaIds, statuses, from, to, query, agentSkills, tags, resourceIds)
      .then((result) => {
        this.planningAlertsService.exportDraftSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.planningAlertsService.exportDraftError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise
  }

  deleteRoutes(ids?, branchIds?, excludedIds?, from?, to?, agentSkills?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.deleteRoutes(ids, branchIds, excludedIds, from, to, agentSkills)
      .then((result) => {
        if (result.length > 1) {
          this.leanPlanningAlertsService.deleteManySuccess(result.length);
        } else {
          this.leanPlanningAlertsService.deleteOneSuccess();
        }
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.leanPlanningAlertsService.deleteManyError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  resetRoutes(ids?, branchIds?, excludedIds?, from?, to?, resetOnlyAssignAgentServices?, agentSkills?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.resetRoutes(ids, branchIds, excludedIds, from, to, resetOnlyAssignAgentServices, agentSkills)
      .then((result) => {
        if (result.length > 1) {
          this.leanPlanningAlertsService.resetManySuccess();
        } else {
          this.leanPlanningAlertsService.resetSuccess();
        }
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.leanPlanningAlertsService.resetManyError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  mergeRoutes(ids, branchIds, excludedIds, from, to, agentSkills?: string[], query?: string, areaIds?: string[], statuses?: string[],
              resourceIds?: string[], tags?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.mergeRoutes(ids, branchIds, excludedIds, from, to, agentSkills, query, areaIds, statuses, resourceIds, tags)
      .then((result) => {
        this.leanPlanningAlertsService.mergeRoutesSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.leanPlanningAlertsService.mergeRoutesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
    return deferred.promise
  }

  assignRoutesToAttachedAgents(ids, branchIds, excludedIds, from, to, agentSkills?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.assignRoutesToAttachedAgents(ids, branchIds, excludedIds, from, to, agentSkills)
      .then((result) => {
        this.leanPlanningAlertsService.assignSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        this.leanPlanningAlertsService.assignError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateTaskTimeWindow(routeId, id, payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.updateTaskTimeWindow(routeId, id, payload)
      .then((result) => {
        // leanPlanningAlertsService.assignSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        // leanPlanningAlertsService.assignError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateBranch(ids, branchIdsPayload, branchIds, excludedIds, from, to, agentSkills?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.updateBranch(ids, branchIdsPayload, branchIds, excludedIds, from, to, agentSkills)
      .then((result) => {
        // leanPlanningAlertsService.assignSuccess();
        deferred.resolve(result);
      })
      .catch((error) => {
        this.$log.error(error);
        // leanPlanningAlertsService.assignError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getLogsTimeline(routeId, limit) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.getLogsTimeline(routeId, limit)
      .then((timeline) => {
        deferred.resolve(timeline)
      })
      .catch((error) => {
        this.leanPlanningAlertsService.getTimelineError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  onGetBOLRoutesIdsToPdf(routesIds) {
    if (!routesIds.length) {
      return;
    }
    const deferred = this.$q.defer<any>();

    this.bringozLoaderService.on();
    this.routeRequestsService.getPDFBolByRoutesIds(routesIds)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.getBOLError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  onPrintBOL(routesIds) {
    this.onGetBOLRoutesIdsToPdf(routesIds)
      .then((res) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"));
        }
      })
  }

  onDownloadBOL(routesIds) {
    this.onGetBOLRoutesIdsToPdf(routesIds)
      .then((res) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  printRoutes(routesIds) {
    const siteId = this.splitService.getSiteId();
    if (!siteId || !routesIds?.length) {
      return;
    }
    var url = this.$state.href('print.routes', {routeIds: routesIds, siteId: siteId});
    this.analyticsService.trackEvent('Routes Actions', 'Print Routes', 'Click');
    this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  }

  printLoadingSheet(routesIds) {
    const siteId = this.splitService.getSiteId();
    if (!siteId || !routesIds?.length) {
      return;
    }
    var url = this.$state.href('print.loading-sheets', {routeIds: routesIds, siteId: siteId});
    this.analyticsService.trackEvent('Routes Actions', 'Print Loading Sheet', 'Click');
    this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  }

  getRouteTasksData(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.getRouteTasksData(payload)
      .then(res => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateRoute(route) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.updateRoute(route)
      .then(res => {
        this.leanPlanningAlertsService.updateRouteSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.updateRouteError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getRoutesList(query: RoutesListPayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.getRoutesList(query)
      .then(res => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  assignAssistant(routeId, assistantIdList: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.assignAssistant(routeId, assistantIdList)
      .then(res => {
        this.leanPlanningAlertsService.assignAssistantsSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignAssistantsError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  assignAssistants(routeIds: string[], assistantIdList: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.assignAssistants(routeIds, assistantIdList)
      .then(res => {
        this.leanPlanningAlertsService.assignAssistantsSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignAssistantsError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  assignLogisticVehicles(routeIds: string[], mainLogisticVehicleId?: string, attachedLogisticVehicleIds?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.routeRequestsService.assignLogisticVehicles(routeIds, mainLogisticVehicleId, attachedLogisticVehicleIds)
      .then(res => {
        this.leanPlanningAlertsService.assignAssistantsSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignAssistantsError();
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  // DEPRECATED
  // changeRouteResource(routeId: string, destinationResource, queries?: ChangeRouteResourceQueryModelModel) {
  //   const deferred = this.$q.defer();
  //
  //   this.bringozLoaderService.on();
  //   this.routeRequestsService.changeRouteResource(routeId, destinationResource)
  //     .then(res => {
  //       this.leanPlanningAlertsService.changeRouteResourceSuccess();
  //       deferred.resolve(res);
  //     })
  //     .catch((error) => {
  //       this.leanPlanningAlertsService.changeRouteResourceError();
  //       this.$log.error(error);
  //       deferred.reject(error)
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     });
  //
  //   return deferred.promise;
  // }

  associateAgent(rids: string[], agentId: string, branchIds?: string[]) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.routeRequestsService.associateAgent(rids, agentId, branchIds)
        .then((resolvedRoutes) => {
          this.leanPlanningAlertsService.assignSuccess();
          resolve(resolvedRoutes);
        })
        .catch((error) => {
          this.leanPlanningAlertsService.assignError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getTaskList(list: RouteTaskModel[], isTaskGrouped: boolean): TaskModel[] {
    const tasks: TaskModel[] = [];

    list.forEach((task: RouteTaskModel) => {
      const taskList = task.bundledRouteTaskList || task.bundledTaskList || [];

      if (!isTaskGrouped && taskList.length) {
        taskList.forEach((bundledTask: RouteTaskModel, index: number) => {
          const resultTask: TaskModel = this._toTaskModel(task, bundledTask);

          // we remove the bundle specific properties since it's not a bundle anymore
          resultTask.bundleServiceIdList = undefined;
          resultTask.bundledTaskIdList = undefined;
          resultTask.bundledRouteTaskList = undefined;
          resultTask.taskType = TaskType.Stopover;
          resultTask.serviceId = task.bundleServiceIdList?.[index] || bundledTask.serviceId;
          resultTask.serviceExternalId = bundledTask.serviceExternalId || bundledTask.externalId;
          tasks.push(resultTask);
        });
      } else {
        tasks.push(this._toTaskModel(task));
      }
    });

    return tasks;
  }

  getCounterpartTaskIds(task: TaskModel, tasks: TaskModel[]): string[] {
    if (!task || task.taskType === TaskType.Internal) {
      return [];
    }
    const purpose = task.taskSpec?.purpose;
    if (purpose !== 'Pickup' && purpose !== 'Dropoff') {
      return [];
    }

    const targetPurpose = purpose === 'Pickup' ? 'Dropoff' : 'Pickup';
    const taskServiceIds = task.bundleServiceIdList && task.bundleServiceIdList.length
      ? task.bundleServiceIdList
      : [task.serviceId];

    return tasks
      .filter(t => t.id !== task.id && t.taskSpec?.purpose === targetPurpose)
      .filter(t => {
        const tServiceIds = t.bundleServiceIdList && t.bundleServiceIdList.length
          ? t.bundleServiceIdList
          : [t.serviceId];
        return _.intersection(taskServiceIds, tServiceIds).length > 0;
      })
      .map(t => t.id);
  }

  private _toTaskModel(task: RouteTaskModel, override?: RouteTaskModel): TaskModel {
    return Object.assign(_.cloneDeep(task), override) as unknown as TaskModel;
  }
}

angular
  .module('bringoz.admin.routes')
  .service('routesService', RoutesService);
